import { p as proxyCustomElement, H, c as createEvent, h, F as Fragment } from './index.js';
import { i as isDefined } from './p-D_OOeJgV.js';
import { g as getValidityObject, c as checkValidity, r as reportValidity, s as setCustomValidity, a as setInputRef, b as getError, w as watchValue, d as watchError, e as watchWarning, f as renderFormField } from './p-Cg8AdZPK.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isLavOption, a as isLav } from './p-CdnDatdH.js';
import { h as handleOptions } from './p-D36toVjT.js';
import { H as HiddenHTMLSelect } from './p-BYoISW3Y.js';
import { d as defineCustomElement$l } from './p-C_esi8gV.js';
import { d as defineCustomElement$k } from './p-Cd2X-6KG.js';
import { d as defineCustomElement$j } from './p-CDhEAnE1.js';
import { d as defineCustomElement$i } from './p-BChudHaw.js';
import { d as defineCustomElement$h } from './p-VRJNF0zT.js';
import { d as defineCustomElement$g } from './p-D-k_i6-R.js';
import { d as defineCustomElement$f } from './p-DMseB40X.js';
import { d as defineCustomElement$e } from './p-aAvJ0uEW.js';
import { d as defineCustomElement$d } from './p-CvrZ72pZ.js';
import { d as defineCustomElement$c } from './p-Ddagsfv6.js';
import { d as defineCustomElement$b } from './p-D4xpFZtu.js';
import { d as defineCustomElement$a } from './p-Brrpvenv.js';
import { d as defineCustomElement$9 } from './p-Cy8qWWQl.js';
import { d as defineCustomElement$8 } from './p-DLWyhg_S.js';
import { d as defineCustomElement$7 } from './p-COzY0iW2.js';
import { d as defineCustomElement$6 } from './p-BqzjvfBR.js';
import { d as defineCustomElement$5 } from './p-DE-WBrSS.js';
import { d as defineCustomElement$4 } from './p-aqq22Qbe.js';
import { d as defineCustomElement$3 } from './p-BqnaoLp8.js';
import { d as defineCustomElement$2 } from './p-B4Sv5V7D.js';

const multiSelectInputCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;box-sizing:border-box;display:flex;flex-direction:column;font-family:Open Sans;font-size:.875rem;font-weight:400;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal;width:100%}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}";

const WuiMultiSelectInput$1 = /*@__PURE__*/ proxyCustomElement(class WuiMultiSelectInput extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        this.validityChecked = createEvent(this, "validityChecked", 7);
        this.validityReported = createEvent(this, "validityReported", 7);
        this.required = false;
        this.validity = getValidityObject();
        this.validationMessage = '';
        this.customValidation = undefined;
        this.checkValidity = checkValidity(this);
        this.reportValidity = reportValidity(this);
        this.setCustomValidity = setCustomValidity(this);
        this.showValidity = false;
        this.setInputRef = setInputRef(this);
        this.dirty = false;
        this.getError = getError(this);
        //////// FORM FIELD END ////////
        /**
         * Options
         */
        this.options = [];
        this.optionsResolved = [];
        /**
         * Size of the scroll container
         */
        this.listSize = 'lg';
        /**
         * Controls dropdown open state
         */
        this.open = false;
        /**
         * If disabled
         */
        this.disabled = false;
        /**
         * Show loading spinner
         *
         * Note: the loading state is automatically enabled when using async options
         */
        this.loading = false;
        this.handleClear = (event) => {
            // Stop from bubbling up to parent button
            event.stopPropagation();
            if (this.disabled) {
                return;
            }
            this.setValue(undefined);
        };
        this.handleInput = (e) => {
            // Stop the inner input event from bubbling up
            e.stopPropagation();
            // Keep menu open
            if (!this.disabled) {
                this.open = false;
            }
            const target = e.target;
            if (!target) {
                return;
            }
            this.setValue(target.value);
        };
    }
    _handleValueChange(newValue) {
        watchValue(this, newValue);
    }
    _watchError(...args) {
        watchError(this, ...args);
    }
    _watchWarning(...args) {
        watchWarning(this, ...args);
    }
    async watchOptions(newValue) {
        return handleOptions(this, newValue);
    }
    async _handleKeyDown(e) {
        const wuiMenuPaneElement = this.elm.shadowRoot?.querySelector('wui-menu-pane');
        if (wuiMenuPaneElement && (await wuiMenuPaneElement.handleKeyDown(e))) {
            // Event was handled by menu pane
            this.open = !!wuiMenuPaneElement.open;
            return;
        }
        const wuiListElement = this.elm.shadowRoot?.querySelector('wui-list');
        if (wuiListElement && (await wuiListElement.handleKeyDown(e))) {
            // Keep it open when item was selected
            if (e.key === 'Enter') {
                this.open = true;
            }
            return;
        }
    }
    setValue(newValue) {
        this.value = newValue;
        this.dirty = true;
        this.elm.dispatchEvent(new window.Event('input', { bubbles: true }));
    }
    componentWillLoad() {
        const old = {
            loading: this.loading,
            disabled: this.disabled,
        };
        this.loading = true;
        this.disabled = true;
        this.watchOptions(this.options).then(() => {
            this.loading = old.loading;
            this.disabled = old.disabled;
        });
    }
    renderInner() {
        const errorType = this.getError().type;
        const limitReached = typeof this.limit === 'number' ? (this.value ?? []).length >= this.limit : false;
        const label = typeof this.label === 'function' ? this.label(this.value) : this.label;
        const options = this.optionsResolved
            .map((option) => {
            if (!isLavOption(option)) {
                return option;
            }
            const isSelected = this.value?.includes(toValue(option));
            // When the component is disabled, we only show selected items
            if (this.disabled && !isSelected) {
                return undefined;
            }
            // Disabled priority:
            const isDisabled = 
            // 1. whole component is disabled
            this.disabled ||
                // 2. option is disabled
                (isLav(option) && option.disabled) ||
                // 3. limit is reached
                (limitReached && !isSelected);
            return {
                label: toLabel(option),
                value: toValue(option),
                disabled: isDisabled,
            };
        })
            .filter(isDefined);
        return (h(Fragment, null, h(HiddenHTMLSelect, { value: this.value, options: options, required: !!this.required, name: this.name, multiple: true, ref: this.setInputRef }), h("wui-input-menu", { inputButton: {
                label,
                value: this.value?.length,
                icon: this.icon,
                readOnly: this.disabled && !!this.value?.length,
                errorType,
            }, menuPane: this.menuPane, open: this.open,
            // Let users see selected options
            disabled: (this.disabled && !this.value?.length) || this.loading, loading: this.loading, onClear: this.handleClear }, h("wui-check-list-input", { value: this.value, options: options, list: { scrollSize: 'md' }, onInput: this.handleInput, disabled: this.disabled || this.loading, name: this.name }))));
    }
    render() {
        return renderFormField(this, this.renderInner(), {
            host: {
                class: this.open ? ' -open' : '',
            },
        });
    }
    get elm() { return this; }
    static get watchers() { return {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"],
        "options": ["watchOptions"]
    }; }
    static get style() { return multiSelectInputCss; }
}, [257, "wui-multi-select-input", {
        "value": [1040],
        "required": [8],
        "error": [8],
        "warning": [8],
        "validate": [16],
        "validity": [1040],
        "validationMessage": [1025, "validation-message"],
        "checkValidity": [16, "check-validity"],
        "reportValidity": [16, "report-validity"],
        "setCustomValidity": [16, "set-custom-validity"],
        "formField": [16, "form-field"],
        "options": [16],
        "label": [1],
        "icon": [1],
        "listSize": [1, "list-size"],
        "menuPane": [16, "menu-pane"],
        "open": [1028],
        "limit": [2],
        "disabled": [1540],
        "loading": [1028],
        "name": [1],
        "customValidation": [32],
        "showValidity": [32]
    }, [[0, "keydown", "_handleKeyDown"]], {
        "value": ["_handleValueChange"],
        "error": ["_watchError"],
        "warning": ["_watchWarning"],
        "options": ["watchOptions"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-multi-select-input", "wui-badge", "wui-box", "wui-check-input", "wui-check-list-input", "wui-close-button", "wui-divider", "wui-form-field", "wui-icon", "wui-input-button", "wui-input-menu", "wui-list", "wui-list-item", "wui-list-item-divider", "wui-list-item-header", "wui-list-item-meta", "wui-loader", "wui-menu-pane", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-multi-select-input":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiMultiSelectInput$1);
            }
            break;
        case "wui-badge":
            if (!customElements.get(tagName)) {
                defineCustomElement$l();
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$k();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$j();
            }
            break;
        case "wui-check-list-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$i();
            }
            break;
        case "wui-close-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$h();
            }
            break;
        case "wui-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$g();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$f();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-input-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-input-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list-item-divider":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item-header":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-list-item-meta":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiMultiSelectInput = WuiMultiSelectInput$1;
const defineCustomElement = defineCustomElement$1;

export { WuiMultiSelectInput, defineCustomElement };
